import React from 'react';

const Container = ({children, styles = {}}) => {

  return (
    <div style={{...containerStyles.container, ...styles}}>
      {children}
    </div>
  );
};

const containerStyles = {
  container: {
    width: '100%',
    maxWidth: 1350,
    marginLeft: 'auto',
    marginRight: 'auto',
    paddingLeft: 30,
    paddingRight: 30,
  }
};

export default Container;
